import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '@verlo/shared/components/ui/button';
import { Notice } from '@verlo/shared/components/ui/notice';
import ZRead from '@verlo/shared/components/ZRead';
import { cashApi } from '@verlo/shared/services/api';
import { useApp } from '@verlo/shared/contexts/AppContext';
import { ArrowLeft, Printer } from 'lucide-react';
import { PageHeader, Loading } from '../../../components/office';

/** One cash-up: the session's Z read as the till froze it. `/back-office/reports/cash-ups/:sessionId`. */
const CashUpPage = () => {
  const { sessionId } = useParams();
  const navigate = useNavigate();
  const { formatCurrency } = useApp();
  const [session, setSession] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let live = true;
    cashApi.session(sessionId).then(({ data }) => { if (live) setSession(data); }).catch(() => { if (live) setErr(true); });
    return () => { live = false; };
  }, [sessionId]);

  return (
    <div data-testid="cash-up-page">
      <PageHeader
        title={session ? `Cash-up · ${session.terminal_label || session.terminal_id} · Z ${session.z_number ?? '—'}` : 'Cash-up'}
        purpose={session ? `${session.trading_date}${session.closed_by_name ? ` · signed off by ${session.closed_by_name}` : ''}` : undefined}
        actions={(
          <>
            <Button variant="outline" size="sm" onClick={() => navigate('/back-office/reports/cash-ups')} className="no-print"><ArrowLeft size={14} className="mr-1.5" />Cash-ups</Button>
            <Button variant="outline" size="sm" onClick={() => window.print()} className="no-print" data-testid="cash-up-print"><Printer size={14} className="mr-1.5" />Print</Button>
          </>
        )}
      />
      {err && <Notice tone="stop" word="Cash-up" title="That cash-up could not be found" />}
      {!err && !session && <Loading shape="tiles" count={2} />}
      {session && (
        <div className="rounded-lg border border-hairline bg-white p-5 print:border-0 print:p-0">
          <ZRead session={session} formatCurrency={formatCurrency} />
        </div>
      )}
    </div>
  );
};

export default CashUpPage;
